import { render, staticRenderFns } from "./FoliaStockOverview.vue?vue&type=template&id=e61b3a8e&"
import script from "./FoliaStockOverview.vue?vue&type=script&lang=js&"
export * from "./FoliaStockOverview.vue?vue&type=script&lang=js&"
import style0 from "./FoliaStockOverview.vue?vue&type=style&index=0&id=e61b3a8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports